import { render, staticRenderFns } from "./PinkProtocol.vue?vue&type=template&id=a5e1e6ce&"
import script from "./PinkProtocol.vue?vue&type=script&lang=js&"
export * from "./PinkProtocol.vue?vue&type=script&lang=js&"
import style0 from "./PinkProtocol.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports